<div class="title">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.API_ACCOUNT_TRIGGER.ACCOUNT_TITLE' | translate }}
</div>

<div class="alert-wrapper">
  <glxy-alert type="tip">
    <div
      [innerHtml]="
        'AUTOMATIONS.EDITOR.TRIGGERS.API_ACCOUNT_TRIGGER.API_DOCS'
          | translate : { automationId: automationId }
          | iTrustThisHtml
      "
    ></div>
  </glxy-alert>
</div>
